<template>
    <div class="edit-pages-menu-form">
        <div class="info">Caso queria exibir as páginas no menu, utilize o botão abaixo de cada campo.</div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="content">
                <b-form-group>
                    <b-form-input v-model="form.home.name" placeholder="Digite aqui."></b-form-input>
                </b-form-group>

                <div>
                    <ToggleSwitchPP
                        :isChecked="form.home.active"
                        :showTextValue="true"
                        @changeValueAction="onChangeSwitch"
                    />
                </div>
            </div>

            <div class="footer-buttons">
                <hr class="line" />

                <b-button type="submit" class="radius-6 submit" :variant="'primary'">
                    Alterar
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import ToggleSwitchPP from '@/ui/toggle-switch-pp/ToggleSwitchPP'

export default {
    name: 'EditPagesMenuForm',
    components: { ToggleSwitchPP },
    data() {
        return {
            form: {
                home: {
                    name: null,
                    active: false
                }
            }
        }
    },
    methods: {
        onSubmit() {
            // console.log('submit >>>', this.form)
        },
        onChangeSwitch(value) {
            this.form.home.active = value
        }
    }
}
</script>

<style scope src="./EditPagesMenuForm-light-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-menu-form/EditPagesMenuForm.vue